import { createRef } from "react";

const state = {
  sections: 8,
  pages: 8,
  zoom: 1,
  top: createRef(),
};

export default state;
